<script setup lang="ts">
import { ref, onBeforeMount, watch } from "vue";
import { useApiClient } from "@/api/client";
import PriceUpdateStatsDTO = Modules.BookingExperts.Data.PriceUpdateStatsDTO;
import { formatNumber } from "chartjs-graph";
import { useHomeStore } from "@/modules/home/store";

const store = useHomeStore();
const api = useApiClient("bookingExperts");

const isLoading = ref(true);
const sparkLineValues = ref<PriceUpdateStatsDTO | null>(null);

watch(() => store.daysToLookBack, fetchPriceUpdates);
onBeforeMount(() => fetchPriceUpdates());

async function fetchPriceUpdates() {
	isLoading.value = true;
	const response = await api.getPriceUpdateStats(store.daysToLookBack);
	if (response.isOk()) {
		sparkLineValues.value = response.value;
	}
	isLoading.value = false;
}
</script>

<template>
	<v-card class="home-graph-card">
		<div
			class="bg-background d-flex flex-row justify-space-between align-center"
			style="height: 48px"
		>
			<div class="v-card-title">Price</div>
			<v-tabs
				v-model="store.daysToLookBack"
				density="default"
				class="condensed-tab-width"
				style="background-color: transparent"
			>
				<v-tab :value="7"> 7 days </v-tab>
				<v-tab :value="30"> 30 days </v-tab>
				<v-tab :value="365"> 365 days </v-tab>
			</v-tabs>
		</div>

		<div class="d-flex flex-column justify-space-between">
			<div class="pa-3">
				<div class="d-flex align-center">
					<v-chip
						variant="tonal"
						color="rgb(107, 91, 231)"
						size="large"
						style="font-size: 28px; font-weight: 500"
					>
						{{ formatNumber(sparkLineValues?.sum) }}
					</v-chip>
					<span class="ml-2">Updated in Bex</span>
					<v-spacer />
					<div>
						<v-avatar
							color="rgb(107, 91, 231)"
							variant="tonal"
							class="rounded-md"
						>
							<v-icon size="24">
								fa: fa-light fa-display-chart-up-circle-dollar
							</v-icon>
						</v-avatar>
					</div>
				</div>
			</div>
			<v-sparkline
				v-if="sparkLineValues"
				:model-value="sparkLineValues?.values"
				:gradient="['rgba(107, 91, 231, 0.05)', 'rgba(107, 91, 231, 0.2)']"
				color="rgba(107, 91, 231, 0.7)"
				height="100"
				stroke-linecap="round"
				line-width="2"
				fill
				smooth
				type="trend"
				:show-labels="false"
				padding="0"
			>
			</v-sparkline>
		</div>
	</v-card>
</template>

<style lang="scss">
.home-graph-card {
	display: grid;
	grid-template-rows: auto 1fr;
}

.condensed-tab-width .v-tab {
	min-width: auto !important;
	width: auto;
	height: 45px;
	font-size: 12px;
	padding: 0 0.75rem;
}
</style>
